import React from 'react';
import {
    makeStyles,
    Theme,
    Typography,
    Box,
    Grid,
    Checkbox,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Capitalize } from 'src/utils/capitalize';
import { IPurchaseReason } from './types';
import { PURCHASE_REASON } from 'src/constants/lead/evaluation';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    reasonItem: {
        display: 'flex',
        alignItems: 'center',
    },
}));

export const PurchaseReasons = ({
    purchaseReasons,
    setFieldValue,
    isEditable,
    ...props
}: IPurchaseReason) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const handleCheckboxChange = (index: number) => {
        const updatedReasons = purchaseReasons.map((reason, idx) =>
            idx === index ? { ...reason, isChecked: !reason.isChecked } : reason
        );
        setFieldValue(PURCHASE_REASON, updatedReasons);
    };

    return (
        <Box className={classes.root} {...props}>
            <Typography variant="h4" color="textPrimary">
                {t('evaluation.purchaseReason')}
            </Typography>
            <Grid container spacing={1}>
                {purchaseReasons?.length === 0 && (
                    <Grid item xs={12} sm={6}>
                        <Typography variant="caption">
                            {t('evaluation.notPurchaseReasons')}
                        </Typography>
                    </Grid>
                )}
                {purchaseReasons?.map((reason, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        className={classes.reasonItem}
                        key={index}
                    >
                        <Checkbox
                            checked={reason?.isChecked}
                            disabled={!isEditable}
                            onChange={() => handleCheckboxChange(index)}
                        />
                        <Typography variant="body1" color="textPrimary">
                            {Capitalize(reason.name)}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
